// extracted by mini-css-extract-plugin
export var productImage = "_ks-1";
export var viewLink = "_ks-2";
export var wishlistItem = "_ks-0";